// OCR Computer Science GCSE 2024 Specification Topics
// Component 01: Computer systems

export const ocrTopics = {
  networking: {
    category: "1.3 - Networks",
    topics: [
      {
        id: "1.3.1-a",
        code: "1.3.1.a",
        title: "Types of networks",
        subtopics: ["LAN (Local Area Network)", "WAN (Wide Area Network)", "Differences between LAN and WAN"],
      },
      {
        id: "1.3.1-b",
        code: "1.3.1.b",
        title: "Network topologies",
        subtopics: ["Star topology", "Mesh topology", "Advantages and disadvantages"],
      },
      {
        id: "1.3.1-c",
        code: "1.3.1.c",
        title: "Wired and wireless networks",
        subtopics: ["Ethernet", "Wi-Fi", "Bluetooth", "Advantages and disadvantages"],
      },
      {
        id: "1.3.1-d",
        code: "1.3.1.d",
        title: "Network protocols",
        subtopics: ["TCP/IP", "HTTP/HTTPS", "FTP", "SMTP", "IMAP"],
      },
      {
        id: "1.3.1-e",
        code: "1.3.1.e",
        title: "Network layering",
        subtopics: ["Layered approach", "Benefits of layering", "TCP/IP model"],
      },
      {
        id: "1.3.2-a",
        code: "1.3.2.a",
        title: "Network hardware",
        subtopics: ["Router", "Switch", "Wireless Access Point (WAP)", "NIC (Network Interface Card)"],
      },
      {
        id: "1.3.2-b",
        code: "1.3.2.b",
        title: "IP and MAC addressing",
        subtopics: ["IP addressing (IPv4)", "MAC addressing", "Differences between IP and MAC"],
      },
      {
        id: "1.3.2-c",
        code: "1.3.2.c",
        title: "Standards",
        subtopics: ["Importance of standards", "Common standards (e.g., IEEE 802.3, 802.11)"],
      },
      {
        id: "1.3.3-a",
        code: "1.3.3.a",
        title: "The internet",
        subtopics: ["Structure of the internet", "Packet switching", "Routers"],
      },
      {
        id: "1.3.3-b",
        code: "1.3.3.b",
        title: "DNS (Domain Name System)",
        subtopics: ["Purpose of DNS", "How DNS works", "DNS hierarchy"],
      },
      {
        id: "1.3.3-c",
        code: "1.3.3.c",
        title: "Hosting",
        subtopics: ["Web hosting", "Cloud hosting", "The cloud"],
      },
      {
        id: "1.3.4-a",
        code: "1.3.4.a",
        title: "Network security threats",
        subtopics: ["Malware", "Phishing", "Brute force attacks", "Denial of Service (DoS)", "SQL injection"],
      },
      {
        id: "1.3.4-b",
        code: "1.3.4.b",
        title: "Network security measures",
        subtopics: ["Firewalls", "Encryption", "User authentication", "MAC address filtering"],
      },
    ],
  },
};

// Helper function to get all topics as flat array
export function getAllTopics() {
  const topics = [];
  Object.values(ocrTopics).forEach(category => {
    category.topics.forEach(topic => {
      topics.push({
        ...topic,
        category: category.category,
      });
    });
  });
  return topics;
}

// Get topics by code
export function getTopicsByCode(codes) {
  const allTopics = getAllTopics();
  return allTopics.filter(topic => codes.includes(topic.code));
}

export default ocrTopics;
